import React from 'react';
import { XCircleIcon, CheckCircleIcon } from '@heroicons/react/24/outline';

const SeatCapacitySection = ({ validationData, onOpenDrawer }) => {
    const sessionsWithIssues = validationData?.seat_capacity_balance?.session_analysis || [];
    const countIssues = sessionsWithIssues.filter(
        (s) => s.issue_type === 'insufficient_rowers' || s.issue_type === 'excess_rowers'
    ).length;

    return (
        <div className="rounded-lg bg-white p-4 shadow sm:p-6">
            <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
                <div className="flex-1">
                    <div className="mb-2 flex items-center gap-3">
                        <div className="flex h-8 w-8 items-center justify-center rounded-full bg-blue-100 text-sm font-medium text-blue-600">
                            3
                        </div>
                        <div>
                            <h3 className="text-base font-medium text-gray-900">Balance Seat Capacity</h3>
                            <p className="text-sm text-gray-600">Manage rower exclusions to match available seats</p>
                        </div>
                    </div>

                    {countIssues > 0 ? (
                        <div className="ml-11">
                            <div className="mb-2 flex items-center gap-2">
                                <XCircleIcon className="h-4 w-4 text-red-500" />
                                <span className="text-sm text-red-600">{countIssues} session{countIssues === 1 ? '' : 's'} need attention</span>
                            </div>
                        </div>
                    ) : (
                        <div className="ml-11">
                            <div className="flex items-center gap-2 text-green-600">
                                <CheckCircleIcon className="h-4 w-4 text-green-500" />
                                <span className="text-sm">Seat capacity is balanced</span>
                            </div>
                        </div>
                    )}
                </div>
                <div className="sm:ml-4">
                    <button
                        onClick={onOpenDrawer}
                        className={`w-full rounded px-3 py-1.5 text-sm font-medium text-white sm:w-auto ${countIssues > 0 ? 'bg-blue-600 hover:bg-blue-700' : 'bg-gray-600 hover:bg-gray-700'
                            }`}
                    >
                        {countIssues > 0 ? 'Manage Exclusions' : 'Edit Exclusions'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SeatCapacitySection;


